"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var VMOperatorCompiler_1;
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMOperatorCompiler = void 0;
const inversify_1 = require("inversify");
const IVMCompilerUtils_1 = require("../../../../interfaces/vm-transformers/IVMCompilerUtils");
const ServiceIdentifiers_1 = require("../../../../container/ServiceIdentifiers");
const VMOpCode_1 = require("../../../../enums/vm-transformers/VMOpCode");
const NodeGuards_1 = require("../../../../node/NodeGuards");
const VMVariableResolver_1 = require("../../VMVariableResolver");
const VMSharedTypes_1 = require("../../../../types/vm-transformers/VMSharedTypes");
let VMOperatorCompiler = VMOperatorCompiler_1 = class VMOperatorCompiler {
    compileBinaryExpression(node, context) {
        var _a, _b;
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.left);
        (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.expression(node.right);
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        const op = VMOperatorCompiler_1.binaryOpMap[node.operator];
        if (op !== undefined) {
            builder.emitRaw({ op });
        }
        else {
            builder.pop().pushUndefined();
        }
    }
    compileUnaryExpression(node, context) {
        var _a;
        if (node.operator === 'delete') {
            this.compileDeleteExpression(node, context);
            return;
        }
        if (node.operator === 'typeof' && NodeGuards_1.NodeGuards.isIdentifierNode(node.argument)) {
            const varName = node.argument.name;
            if (varName !== 'arguments') {
                const resolution = this.variableResolver.resolve(varName, context);
                if (resolution.location === VMSharedTypes_1.VariableLocation.Global) {
                    const builder = this.vmCompilerUtils.createInstructionBuilder(context);
                    builder.typeofGlobal(resolution.index);
                    return;
                }
            }
        }
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.argument);
        const op = VMOperatorCompiler_1.unaryOpMap[node.operator];
        if (op !== undefined) {
            const builder = this.vmCompilerUtils.createInstructionBuilder(context);
            builder.emitRaw({ op });
        }
    }
    compileLogicalExpression(node, context) {
        var _a, _b;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.left);
        builder.dup();
        const jumpOp = node.operator === '&&'
            ? VMOpCode_1.VMOpCode.JUMP_IF_FALSE
            : node.operator === '||'
                ? VMOpCode_1.VMOpCode.JUMP_IF_TRUE
                : VMOpCode_1.VMOpCode.JUMP_NULLISH;
        const skipIndex = this.vmCompilerUtils.emitConditionalJump(jumpOp, context);
        builder.pop();
        (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.expression(node.right);
        this.vmCompilerUtils.patchJump(skipIndex, context);
    }
    compileUpdateExpression(node, context) {
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        if (NodeGuards_1.NodeGuards.isMemberExpressionNode(node.argument)) {
            this.compileUpdateMemberExpression(node, context);
            return;
        }
        if (!NodeGuards_1.NodeGuards.isIdentifierNode(node.argument)) {
            builder.pushUndefined();
            return;
        }
        const varName = node.argument.name;
        this.vmCompilerUtils.emitLoadVariable(varName, context);
        if (!node.prefix) {
            builder.dup();
        }
        builder.loadConst(1);
        if (node.operator === '++') {
            builder.add();
        }
        else {
            builder.subtract();
        }
        if (node.prefix) {
            builder.dup();
        }
        this.vmCompilerUtils.emitStoreVariable(varName, context);
    }
    compileDeleteExpression(node, context) {
        var _a, _b;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        if (NodeGuards_1.NodeGuards.isMemberExpressionNode(node.argument)) {
            const member = node.argument;
            if (member.object.type === 'Super') {
                builder.pushFalse();
                return;
            }
            (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(member.object);
            if (member.computed) {
                if (member.property.type === 'PrivateIdentifier') {
                    builder.pop();
                    builder.pushFalse();
                    return;
                }
                (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.expression(member.property);
                builder.emitRaw({ op: VMOpCode_1.VMOpCode.DELETE_PROP });
            }
            else if (NodeGuards_1.NodeGuards.isIdentifierNode(member.property)) {
                const propIndex = context.constantPool.add(member.property.name);
                builder.emitRaw({ op: VMOpCode_1.VMOpCode.DELETE_PROP, arg: propIndex });
            }
            else {
                builder.pop();
                builder.pushFalse();
                return;
            }
        }
        else {
            builder.pushTrue();
        }
    }
    compileUpdateMemberExpression(node, context) {
        var _a, _b;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        const memberNode = node.argument;
        if (memberNode.computed || !NodeGuards_1.NodeGuards.isIdentifierNode(memberNode.property)) {
            builder.pushUndefined();
            return;
        }
        const propName = memberNode.property.name;
        const propIndex = context.constantPool.add(propName);
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(memberNode.object);
        builder.getPropertyByName(propIndex);
        if (!node.prefix) {
            builder.dup();
        }
        builder.loadConst(1);
        if (node.operator === '++') {
            builder.add();
        }
        else {
            builder.subtract();
        }
        (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.expression(memberNode.object);
        builder.swap();
        builder.setProperty(propIndex);
        if (!node.prefix) {
            builder.pop();
        }
    }
};
exports.VMOperatorCompiler = VMOperatorCompiler;
VMOperatorCompiler.binaryOpMap = {
    '+': VMOpCode_1.VMOpCode.ADD,
    '-': VMOpCode_1.VMOpCode.SUB,
    '*': VMOpCode_1.VMOpCode.MUL,
    '/': VMOpCode_1.VMOpCode.DIV,
    '%': VMOpCode_1.VMOpCode.MOD,
    '**': VMOpCode_1.VMOpCode.EXPONENT,
    '==': VMOpCode_1.VMOpCode.EQ,
    '!=': VMOpCode_1.VMOpCode.NEQ,
    '===': VMOpCode_1.VMOpCode.STRICT_EQ,
    '!==': VMOpCode_1.VMOpCode.STRICT_NEQ,
    '<': VMOpCode_1.VMOpCode.LT,
    '<=': VMOpCode_1.VMOpCode.LTE,
    '>': VMOpCode_1.VMOpCode.GT,
    '>=': VMOpCode_1.VMOpCode.GTE,
    '&': VMOpCode_1.VMOpCode.BIT_AND,
    '|': VMOpCode_1.VMOpCode.BIT_OR,
    '^': VMOpCode_1.VMOpCode.BIT_XOR,
    '<<': VMOpCode_1.VMOpCode.SHL,
    '>>': VMOpCode_1.VMOpCode.SHR,
    '>>>': VMOpCode_1.VMOpCode.USHR,
    in: VMOpCode_1.VMOpCode.IN,
    instanceof: VMOpCode_1.VMOpCode.INSTANCEOF
};
VMOperatorCompiler.unaryOpMap = {
    '+': VMOpCode_1.VMOpCode.UNARY_PLUS,
    '-': VMOpCode_1.VMOpCode.NEG,
    '!': VMOpCode_1.VMOpCode.LOGICAL_NOT,
    '~': VMOpCode_1.VMOpCode.BIT_NOT,
    typeof: VMOpCode_1.VMOpCode.TYPEOF,
    void: VMOpCode_1.VMOpCode.VOID
};
__decorate([
    (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMCompilerUtils),
    __metadata("design:type", typeof (_a = typeof IVMCompilerUtils_1.IVMCompilerUtils !== "undefined" && IVMCompilerUtils_1.IVMCompilerUtils) === "function" ? _a : Object)
], VMOperatorCompiler.prototype, "vmCompilerUtils", void 0);
__decorate([
    (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMVariableResolver),
    __metadata("design:type", typeof (_b = typeof VMVariableResolver_1.VMVariableResolver !== "undefined" && VMVariableResolver_1.VMVariableResolver) === "function" ? _b : Object)
], VMOperatorCompiler.prototype, "variableResolver", void 0);
exports.VMOperatorCompiler = VMOperatorCompiler = VMOperatorCompiler_1 = __decorate([
    (0, inversify_1.injectable)()
], VMOperatorCompiler);
